export const SET_DOCUMENT_SIDEBAR = "@JOBDETAILS/SET_DOCUMENT_SIDEBAR";
export const SET_DOCUMENTS= "@JOBDETAILS/SET_DOCUMENTS";